import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EvStationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ev_station"}/>
}
